import { useNavigate } from 'react-router-dom';
import useSWR from 'swr';
import { exchangeAndReturnService } from 'services';
import { useReturnDetails } from 'pages/exchange-and-return/hooks';
import {
  Accordion,
  Collect,
  CustomerAndPayment,
  DashboardHeader,
  DashboardHistoryAndTracking,
  DashboardSteps,
  Loading,
  Text,
} from 'components';
import { FontSize, StepsEnum, routes, salesMode } from 'commons';
import { ReturnEntries } from './components';
import * as S from './styles';

export function ConsignmentDetails() {
  const navigate = useNavigate();
  const { selectedCard, consignmentDetails, validatingConsignmentsDetails } =
    useReturnDetails();

  const { data: returnEntries, isValidating: validatingReturnEntries } = useSWR(
    selectedCard?.consignmentCode
      ? `return-entries-${selectedCard.consignmentCode}`
      : null,
    () =>
      exchangeAndReturnService.getEntries({
        consignmentCode: selectedCard?.consignmentCode || '',
      }),
    { revalidateOnFocus: false, revalidateOnReconnect: true }
  );

  if (validatingConsignmentsDetails || validatingReturnEntries) {
    return <Loading />;
  }

  if (!consignmentDetails) {
    navigate(routes.exchangeAndReturn.path);

    return null;
  }

  const { code } = consignmentDetails;

  const isPickupInStore = consignmentDetails.salesMode === salesMode.pickup;

  return (
    <S.Main key={returnEntries?.consignmentCode || ''}>
      <DashboardHeader consignment={consignmentDetails} />

      <S.Wrapper>
        <DashboardSteps
          currentStep={StepsEnum.Delivered}
          isPickupInStore={isPickupInStore}
        />

        <Accordion title="Solicitação de devolução" defaultOpen>
          {returnEntries ? (
            <ReturnEntries returnEntries={returnEntries} />
          ) : (
            <Text size={FontSize.font12} className="error">
              Essa remessa não tem produtos disponíveis para devolução
            </Text>
          )}
        </Accordion>

        <Collect consignment={consignmentDetails} />

        <DashboardHistoryAndTracking consignmentCode={code} />

        <CustomerAndPayment consignment={consignmentDetails} />
      </S.Wrapper>
    </S.Main>
  );
}
